import React, { createContext, useContext, useState } from 'react'
import { usePedidoSpotService } from './usePedidoSpotService'
import { useExcelGenerator } from '../../../../hooks/useExcelGenerator'
import { usePdfGeneratorNew } from '../../../../hooks/usePdfGenerator'
import { useToast } from '@chakra-ui/react'

const PedidoSpotContext = createContext({})

export const PedidoSpotProvider = ({ children }) => {
  const pedidoSpotService = usePedidoSpotService()
  const { generateExcel, loading: excelLoading } = useExcelGenerator()
  const { generatePDF, loading: pdfLoading } = usePdfGeneratorNew()
  const toast = useToast()
  const [pedidoParaExcluir, setPedidoParaExcluir] = useState(null)

  const excelHeader = [
    'Data Pedido',
    'Número Pedido SPOT',
    'Número Pedido Innovation',
    'Fornecedor',
    'Valor Total',
    'Status',
    'Empresa',
    'Transportadora',
    'Código Rastreio',
  ]

  const exportarPedidosExcel = () => {
    const dataItems = pedidoSpotService.pedidos.map((pedido) => ({
      data_pedido: formatarData(pedido.data_pedido),
      numero_pedido_spot: pedido.numero_pedido_spot,
      numero_pedido_innovation: pedido.numero_pedido_innovation,
      fornecedor: pedido.fornecedor,
      valor_total:
        typeof pedido.valor_total === 'number' ? pedido.valor_total.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : 'N/A',
      status: pedido.status,
      empresa: pedido.empresa,
      transportadora: pedido.transportadora || 'N/A',
      codigo_rastreio: pedido.codigo_rastreio || 'N/A',
    }))

    generateExcel(excelHeader, dataItems, 'Pedidos-SPOT')
  }

  const exportarPedidosPDF = () => {
    const pdfData = pedidoSpotService.pedidos.map((pedido) => [
      formatarData(pedido.data_pedido),
      pedido.numero_pedido_spot,
      pedido.numero_pedido_innovation,
      pedido.fornecedor,
      typeof pedido.valor_total === 'number' ? pedido.valor_total.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : 'N/A',
      pedido.status,
      pedido.empresa,
      pedido.transportadora || 'N/A',
      pedido.codigo_rastreio || 'N/A',
    ])

    generatePDF(excelHeader, pdfData, 'Pedidos-SPOT')
  }

  const formatarData = (dataString) => {
    if (!dataString) return 'N/A'

    try {
      const data = new Date(dataString)
      return data.toLocaleDateString('pt-BR')
    } catch (e) {
      return dataString
    }
  }

  const excluirPedido = async (pedidoId, ordemPedido) => {
    try {
      if (!ordemPedido) {
        throw new Error('Código do pedido SPOT não informado.')
      }

      await pedidoSpotService.excluirPedido(pedidoId, ordemPedido)
      toast({
        title: 'Pedido cancelado com sucesso',
        description: 'O status do pedido foi atualizado para "cancelado".',
        status: 'success',
        duration: 3000,
        isClosable: true,
      })
    } catch (error) {
      toast({
        title: 'Erro ao cancelar pedido',
        description: error.message || 'Ocorreu um erro ao tentar cancelar o pedido.',
        status: 'error',
        duration: 5000,
        isClosable: true,
      })
    }
  }

  const contextValue = {
    ...pedidoSpotService,
    exportarPedidosExcel,
    exportarPedidosPDF,
    excluirPedido,
    excelLoading,
    pdfLoading,
    pedidoParaExcluir,
    setPedidoParaExcluir,
  }

  return <PedidoSpotContext.Provider value={contextValue}>{children}</PedidoSpotContext.Provider>
}

export const usePedidoSpot = () => useContext(PedidoSpotContext)
